import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();

  const handleEnter = () => {
    navigate('/home');
  };

  return (
    <div className="landing">
      <div className="landing__content" onClick={handleEnter}>
        <div className="landing__image-wrapper">
          <img
            src="https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/open.jpeg"
            alt="Welcome"
            className="landing__image"
          />
          <button
            className="landing__enter"
          >
            enter
          </button>
        </div>
      </div>
    </div>
  );
};

export default Landing;
